import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { SplitPane } from '@sierralabs/core-ui';
import { EntityProvider } from '@sierralabs/entity-ui';
import FormListPanel from './FormListPanel';
import FormEditPanel from './FormEditPanel';
import { FormConfigure } from '../FormConfigure';
import { QueryProvider } from '@sierralabs/query-ui';
import { FormBuilderProvider } from '../FormBuilderContext';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .editor-container {
    flex: 1;
  }
  .navigation-pane {
    min-width: 240px;
  }
  .flex {
    flex: 1;
  }
`;
export const FormEditor = props => {
    const { elementPlugins } = props;
    const { formTemplateId = 0 } = useParams();
    return (React.createElement(EntityProvider, null,
        React.createElement(QueryProvider, null,
            React.createElement(FormBuilderProvider, { elementPlugins: elementPlugins },
                React.createElement(StyledDiv, { className: 'form-editor' },
                    React.createElement(SplitPane, { className: 'editor-container' },
                        React.createElement(SplitPane, { width: 240, primary: 'next', className: 'navigation-pane' },
                            React.createElement(SplitPane, { direction: 'vertical', className: 'form-list-pane' },
                                React.createElement(FormListPanel, null))),
                        React.createElement(SplitPane, { primary: 'next' },
                            React.createElement(SplitPane, { className: 'form-pane' },
                                React.createElement(FormEditPanel, null)),
                            React.createElement(SplitPane, { width: 300, className: 'config-pane' },
                                React.createElement(FormConfigure, null)))))))));
};
export default FormEditor;
//# sourceMappingURL=FormEditor.js.map